import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdateFileDescriptorQuery } from "@/features/project-file-preview";
import { ProjectContext } from "@/stores/project-provider";

export const useSetFileDescription = (descriptorId: string) => {
  const project = useContext(ProjectContext);
  const updateFileDescriptorQuery = useUpdateFileDescriptorQuery();
  return useMutationWithErrorHandler(
    async ({ id, description }: { id: string; description: string }) => {
      const newDescription = (
        await getRanaApiV1().FilesApi.projectFileSetDescription({
          projectId: project.id,
          path: id,
          description: { description },
        })
      ).description;
      updateFileDescriptorQuery(descriptorId, { id: descriptorId, description: newDescription });
    }
  );
};
